import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { ButtonSize } from '../../../../models/BlockComponentValues/BlockComponentButton';

interface ButtonSizePickerProps {
  value: ButtonSize;
  onChangeSize: (value: ButtonSize) => void;
}

const ButtonSizePicker = ({ value, onChangeSize }: ButtonSizePickerProps) => (
  <Box>
    <Typography variant="caption" sx={{ width: '60px' }} className="text-bold" color="#495057">
      サイズ
    </Typography>
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, newValue: ButtonSize) => {
        if (newValue) {
          onChangeSize(newValue);
        }
      }}
      size="small"
      sx={{ marginLeft: 3 }}
    >
      <ToggleButton value={ButtonSize.SMALL} sx={{ paddingX: 2, paddingY: 1 }}>小</ToggleButton>
      <ToggleButton value={ButtonSize.MEDIUM} sx={{ paddingX: 2, paddingY: 1 }}>中</ToggleButton>
      <ToggleButton value={ButtonSize.LARGE} sx={{ paddingX: 2, paddingY: 1 }}>大</ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

export default ButtonSizePicker;
